import React from "react";

const base = "w-full h-auto";

/* Step 1 — a simple event-brief form */
export const DiagramBrief = ({ className = "" }) => (
  <svg viewBox="0 0 400 300" className={`${base} ${className}`} fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
    <rect x="40" y="20" width="240" height="260" rx="14" fill="#FFFFFF" stroke="#E3E8F0" strokeWidth="2" />
    <rect x="70" y="55" width="120" height="12" rx="6" fill="#182B49" />
    <rect x="70" y="90" width="180" height="8" rx="4" fill="#E3E8F0" />
    <rect x="70" y="112" width="180" height="8" rx="4" fill="#E3E8F0" />
    <rect x="70" y="134" width="120" height="8" rx="4" fill="#E3E8F0" />
    <rect x="70" y="168" width="180" height="34" rx="8" fill="#F7F9FC" stroke="#E3E8F0" strokeWidth="1.5" />
    <rect x="70" y="214" width="180" height="34" rx="8" fill="#F7F9FC" stroke="#E3E8F0" strokeWidth="1.5" />
    <circle cx="300" cy="230" r="46" fill="#087E8B" />
    <path d="M282 230 L294 244 L320 214" stroke="#FFFFFF" strokeWidth="7" strokeLinecap="round" strokeLinejoin="round" fill="none" />
  </svg>
);

/* Step 2 — Nirkana at the centre of a curated partner network */
export const DiagramNetwork = ({ className = "" }) => (
  <svg viewBox="0 0 400 300" className={`${base} ${className}`} fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
    <line x1="200" y1="150" x2="90" y2="70" stroke="#E3E8F0" strokeWidth="2" />
    <line x1="200" y1="150" x2="80" y2="170" stroke="#E3E8F0" strokeWidth="2" />
    <line x1="200" y1="150" x2="120" y2="245" stroke="#E3E8F0" strokeWidth="2" />
    <line x1="200" y1="150" x2="300" y2="60" stroke="#E3E8F0" strokeWidth="2" />
    <line x1="200" y1="150" x2="320" y2="160" stroke="#E3E8F0" strokeWidth="2" />
    <line x1="200" y1="150" x2="280" y2="240" stroke="#E3E8F0" strokeWidth="2" />
    <circle cx="90" cy="70" r="22" fill="#F4DFB0" />
    <circle cx="80" cy="170" r="18" fill="#087E8B" />
    <circle cx="120" cy="245" r="20" fill="#182B49" />
    <circle cx="300" cy="60" r="20" fill="#182B49" />
    <circle cx="320" cy="160" r="24" fill="#087E8B" />
    <circle cx="280" cy="240" r="18" fill="#D9A441" />
    <circle cx="200" cy="150" r="42" fill="#182B49" />
    <text x="200" y="156" textAnchor="middle" fontSize="14" fontWeight="700" fill="#FFFFFF" fontFamily="Inter, sans-serif">N</text>
  </svg>
);

/* Step 3 — a single clear quote with one price */
export const DiagramQuote = ({ className = "" }) => (
  <svg viewBox="0 0 400 300" className={`${base} ${className}`} fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
    <rect x="80" y="30" width="240" height="240" rx="14" fill="#FFFFFF" stroke="#E3E8F0" strokeWidth="2" />
    <rect x="108" y="60" width="90" height="10" rx="5" fill="#182B49" />
    <rect x="108" y="90" width="184" height="1.5" fill="#E3E8F0" />
    <rect x="108" y="110" width="120" height="8" rx="4" fill="#E3E8F0" />
    <rect x="260" y="110" width="32" height="8" rx="4" fill="#6B778C" />
    <rect x="108" y="134" width="120" height="8" rx="4" fill="#E3E8F0" />
    <rect x="260" y="134" width="32" height="8" rx="4" fill="#6B778C" />
    <rect x="108" y="158" width="120" height="8" rx="4" fill="#E3E8F0" />
    <rect x="260" y="158" width="32" height="8" rx="4" fill="#6B778C" />
    <rect x="108" y="188" width="184" height="1.5" fill="#E3E8F0" />
    <text x="108" y="222" fontSize="22" fontWeight="700" fill="#182B49" fontFamily="Inter, sans-serif">Total</text>
    <text x="292" y="222" textAnchor="end" fontSize="22" fontWeight="700" fill="#087E8B" fontFamily="Inter, sans-serif">₹</text>
    <circle cx="320" cy="60" r="28" fill="#D9A441" />
    <path d="M308 60 L317 70 L334 48" stroke="#FFFFFF" strokeWidth="5" strokeLinecap="round" strokeLinejoin="round" fill="none" />
  </svg>
);

/* Step 4 — delivery, arriving on schedule */
export const DiagramDelivery = ({ className = "" }) => (
  <svg viewBox="0 0 400 300" className={`${base} ${className}`} fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
    <path d="M40 230 C 140 260, 260 260, 360 230" stroke="#E3E8F0" strokeWidth="2" strokeDasharray="2 10" strokeLinecap="round" />
    <rect x="130" y="110" width="140" height="100" rx="10" fill="#182B49" />
    <rect x="130" y="110" width="140" height="34" rx="10" fill="#087E8B" />
    <rect x="188" y="110" width="24" height="100" fill="#D9A441" opacity="0.85" />
    <circle cx="160" cy="220" r="14" fill="#172033" />
    <circle cx="240" cy="220" r="14" fill="#172033" />
    <circle cx="160" cy="220" r="6" fill="#F7F9FC" />
    <circle cx="240" cy="220" r="6" fill="#F7F9FC" />
    <circle cx="330" cy="150" r="30" fill="#20A67A" />
    <path d="M316 150 L326 162 L346 136" stroke="#FFFFFF" strokeWidth="6" strokeLinecap="round" strokeLinejoin="round" fill="none" />
  </svg>
);

/* Gallery placeholder — a framed "photo coming soon" slot, with a small
   category badge in the corner so each card still reads distinctly. */
export const DiagramPhotoFrame = ({ className = "" }) => (
  <svg viewBox="0 0 200 200" className={`w-full h-auto ${className}`} fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
    <rect x="14" y="14" width="172" height="172" rx="16" fill="#FFFFFF" stroke="#E3E8F0" strokeWidth="2" strokeDasharray="6 8" />
    <circle cx="72" cy="72" r="16" fill="#F4DFB0" />
    <path d="M30 150 L82 98 L112 128 L140 100 L172 150 Z" fill="#E3E8F0" />
  </svg>
);
